import { type Action, type BoundActions, createHook, type HookFunction } from 'react-sweet-state';

import type { UnconnectedApp } from '../../ui/chat-prompt-input/app-connection-banner';

import { store } from './store';
import type { AppConnectionBannerState, ShowBannerOptions } from './types';

export const useAppConnectionBannerStore: HookFunction<
	AppConnectionBannerState,
	BoundActions<
		AppConnectionBannerState,
		{
			/**
			 * Show the app connection banner with the given unconnected apps
			 */
			showBanner: (
				unconnectedApps: UnconnectedApp[],
				options?: ShowBannerOptions,
			) => Action<AppConnectionBannerState>;
			/**
			 * Hide the banner and clear the unconnected apps
			 */
			hideBanner: () => Action<AppConnectionBannerState>;
			/**
			 * Mark an app as connected and remove it from the list
			 */
			markAppAsConnected: (appSource: string) => Action<AppConnectionBannerState>;
		}
	>,
	void
> = createHook(store);
